// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__QtkbH","dragIcon":"SortableItem_dragIcon__mVx-2","disabled":"SortableItem_disabled__1Z7Nl"};